import { apiFetch } from "./apiFetch";

export interface EnvironmentEntity {
  id: string;
}

export interface MeetingType {
  id: string;
  title?: string;
  shortDescription?: string;
  description?: string;
  calendarEventTitle?: string;
  notificationTitle?: string;
  notificationDescription?: string;
  EnvironmentVisibility?: EnvironmentEntity[];
}

export const MeetingTypesResource = {
  getList: () => apiFetch<MeetingType[]>("/admin/meeting-types"),
};
